// Speculation Rules Manager
export class SpeculationManager {
  constructor() {
    this.isSupported = HTMLScriptElement.supports?.('speculationrules');
    this.rulesScript = null;
    this.dynamicRulesScript = null;
    this.init();
  }

  init() {
    if (!this.isSupported) {
      console.log('Speculation Rules API not supported');
      return;
    }

    // Speculation rules disabled - external files not yet supported by browsers
    // this.setupBaseRules();
    // this.monitorUserBehavior();

    window.addEventListener('pagehide', () => this.cleanup());
  }

  setupBaseRules() {
    // Disabled: External speculation rules files are not yet supported by browsers
    // This prevents the "External speculation rules are not yet supported" warning
    console.debug('Speculation rules disabled - external files not supported');
    return;
  }

  addRules(rules) {
    // This method is kept for potential future use with external JSON files
    // but should not be used with inline textContent due to CSP restrictions
    console.warn('addRules: Use external JSON files for speculation rules to comply with CSP');
  }

  monitorUserBehavior() {
    let hoverTimeout;

    document.addEventListener('mouseover', (e) => {
      const link = e.target.closest('a[href]');
      if (!link || !this.shouldSpeculate(link)) return;

      clearTimeout(hoverTimeout);
      hoverTimeout = setTimeout(() => {
        this.addDynamicRule(link.href, 'prefetch');
      }, 200);
    }, { passive: true });

    document.addEventListener('mouseout', () => {
      clearTimeout(hoverTimeout);
    }, { passive: true });
  }

  shouldSpeculate(link) {
    if (link.hostname !== location.hostname) return false;
    if (link.hasAttribute('download')) return false;

    const destructivePatterns = ['/logout', '/delete', '/remove'];
    if (destructivePatterns.some(pattern => link.pathname.includes(pattern))) {
      return false;
    }

    if (this.userPrefersReducedData()) return false;

    return true;
  }

  userPrefersReducedData() {
    return (
      navigator.connection?.saveData ||
      navigator.connection?.effectiveType === 'slow-2g' ||
      navigator.connection?.effectiveType === '2g'
    );
  }

  addDynamicRule(url, type = 'prefetch') {
    if (!this.isSupported) return;

    // Dynamic speculation rules are disabled to comply with CSP restrictions
    // Inline speculation rules violate CSP even with 'unsafe-inline'
    // The base rules from speculation-rules.json provide adequate prefetching coverage
    console.debug('Dynamic speculation rule skipped for CSP compliance:', url);

    // Note: If dynamic rules are needed in the future, implement a server-side
    // solution that generates and serves speculation rule JSON files on-demand
  }

  cleanup() {
    if (this.rulesScript) {
      this.rulesScript.remove();
    }
    if (this.dynamicRulesScript) {
      this.dynamicRulesScript.remove();
    }
  }
}

export default SpeculationManager;
